<template>
  <div class="container">
    <div class="row justify-content-center no-gutters main">
      <div class="col-md-7">
        <img id="logo-orisha" class="d-block"
             src="https://medias.bimedia-it.com/assets/logo_orisha_rs_blanc.svg"/>

        <div class="card card-orisha">
          <div class="card-body">
            <div class="error-container">
              <h2 class="text-center text-danger mb-3">Accès non autorisé</h2>
              <p class="text-center">
                Le client ou l'URL de redirection n'est pas autorisé.
              </p>
            </div>

            <div class="row justify-content-center my-1 mx-auto">
              <div class="col-12 col-sm-6 mb-3">
                <button type="button" class="btn btn-outline-light btn-sm btn-block bg-grey"
                        @click="showRecovery" style="margin-bottom: 5px">
                  Mot de passe oublié ?
                </button>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                <button type="button"
                        class="btn btn-outline-light btn-sm btn-block bg-grey"
                        @click="showRegister">
                  Créer mon compte
                </button>
              </div>
            </div>

            <div class="row justify-content-center my-4 mx-auto">
              <div class="col-12">
                <button type="button" class="btn btn-outline-light btn-sm btn-block bg-grey"
                        @click="goBack">
                  ← Retour
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OAuthUnauthorized',
  methods: {
    oauthFlowQuery() {
      return {
        ...this.$route.query,
        oauth: '1',
      };
    },
    showRecovery() {
      this.$router.push({
        path: '/edit',
        query: this.oauthFlowQuery(),
      });
    },
    showRegister() {
      this.$router.push({
        path: '/create',
        query: this.oauthFlowQuery(),
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.error-container {
  padding: 20px;
}

.text-danger {
  color: #dc3545;
}

.mb-3 {
  margin-bottom: 1rem;
}

.text-center {
  text-align: center;
}

p {
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}
</style>
